import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Avtalsvaljaren = lazy(() => import("@/pages/elavtal/Avtalsvaljaren"));

export const Route = createFileRoute("/elavtal/avtalsvaljaren")({
  head: () => seoHead("/elavtal/avtalsvaljaren"),
  component: () => <Avtalsvaljaren />,
});
